module.exports = __webpack_public_path__ + "static/media/o22.ab317099.png";